import React, { useEffect } from 'react';
import { usePopup } from '../../../hooks';
import styles from './Header.module.scss';

const CSratingsHeader = () => {
  const [setPopup] = usePopup();

  const handleBackButton = async () => {
    sessionStorage.setItem('headerback', 1);
    setPopup({ open: true, popupType: 'csRatingsCloseConfirmation' });
  };

  useEffect(() => {
    setTimeout(() => {
      sessionStorage.setItem('Tooltip', 1);
    }, 3000);
  }, []);

  return (
    <>
      <header className={`${styles.header_box} ${styles.header_blue}`}>
        <div className={`${styles.header_left}`}>
          <div
            onClick={handleBackButton}
            className={`csicon ${styles.page_whiteback_icon} `}
            id="headerback"
            role="presentation"
          />
        </div>
        <div className={`${styles.header_center}`}>
          <div className={`${styles.header_text} text_center`}>
            <div className="font14 fw600 colorFFF text-center">Justdial Support Review</div>
          </div>
        </div>
      </header>
    </>
  );
};

export default CSratingsHeader;
